import React from 'react'
//import Link from 'gatsby-link'
import { Container, List, Divider, Header, Icon, Segment, Message } from 'semantic-ui-react'
import 'semantic-ui-css/semantic.min.css';

const IndexPage = () => (
  <div>
    <Container>
        <Segment padded='very' color='red'>
        <Header as='h1' icon textAlign='center'>
            <Icon name='users' circular />
            <Header.Content>Rejestr akcji</Header.Content>
        </Header>


      <Message>
          Rejestr akcji to usługa księgi akcji dla spółek akcyjnych do prowadzenia księgi akcji zapewniające spójność i prawidłowość zapisów.
          Zapewnia dostęp do historycznego stanu księgi, modyfikacje ze stemplem kryptograficznym w oparciu o technologię Blockchain
      </Message>

        <Divider section />

      <h2>Korzyści</h2>
        <List divided>
            <List.Item>
                <List.Content>
                    <List.Description as='a'>Łatwe raportowanie zmian w akcjonariace spółek z dużą liczbą akcjonariuszy</List.Description>
                </List.Content>
            </List.Item>
            <List.Item>
                <List.Content>
                    <List.Description as='a'>Pewność prawidłowych zapisów w księdze akcji</List.Description>
                </List.Content>
            </List.Item>
            <List.Item>
                <List.Content>
                    <List.Description as='a'>Prezentacja sprawozdań i uchwał</List.Description>
                </List.Content>
            </List.Item>
            <List.Item>
                <List.Content>
                    <List.Description as='a'>Trwały nośnik dzięki wykorzystaniu publicznego rejestru rozproszonego Blockchain</List.Description>
                </List.Content>
            </List.Item>
        </List>
        </Segment>
    </Container>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js